import React from 'react';

import MaskedInput from 'react-text-mask'

import { validateExpDate } from './AcceptJsPayment';
import { Fade } from '../../../componentAnimations'
import { StateInput } from '../../../components';

import './AcceptPaymentForm.css';

const runValidations = (formValues) => ({
  expDate: !validateExpDate(formValues.expDate)
});

export default class AuthorizeProfilePaymentForm extends React.Component {
  constructor(props) {
    super(props);

    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.onFocusHandler = this.onFocusHandler.bind(this);
    this.onBlurHandler = this.onBlurHandler.bind(this);
    this.onHandleSubmit = this.onHandleSubmit.bind(this);
  }

  onChangeHandler = (ev) => {
    const { handleChange } = this.props;
    ev.persist();
    if (handleChange) {
      handleChange(ev.target.name, ev);
    }
  }

  onFocusHandler = (ev) => {
    const { handleFocus } = this.props;
    ev.persist();
    if (handleFocus) {
      handleFocus(ev.target.name, ev);
    }
  }

  onBlurHandler = (ev) => {
    const { handleBlur } = this.props;
    ev.persist();
    if (handleBlur) {
      handleBlur(ev);
    }
  }

  onHandleSubmit = (ev) => {
    const { handleSubmit } = this.props;
    ev.persist();
    if (handleSubmit) {
      handleSubmit(ev);
    }
  }

  FormInput = (props => {
    const { mask, hasError, ...rest } = props;
    const Component = (props.mask && props.mask.length > 0) ? MaskedInput : 'input';
    var cssClass = 'borderBottom form-control';

    if (props.value) {
      cssClass += props.hasError ? ' inValidBorderBottom' : ' validBorderBottom';
    }

    return (
      <Component
        autoCapitalize='off'
        autoCorrect='off'
        className={cssClass}
        type='text'
        onChange={this.onChangeHandler}
        //onFocus={this.onFocusHandler}
        //onBlur={this.onBlurHandler}
        mask={mask}
        {...rest}
      />
    );
  })

  CardNumber = ({
    type = 'text',
    name = 'cardNumber',
    placeholder = '1234 5678 9012 3456',
    ...props
  }) => (
    <this.FormInput
      id='cardNum'
      name={name}
      type={type}
      placeholder={placeholder}
      guide={false}
      maxLength='19'
      mask={[
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/
      ]}
      {...props}
    />
  );

  ExpDate = ({
    type = 'text',
    name = 'expDate',
    placeholder = 'MM/YY',
    ...props
  }) => (
    <this.FormInput
      id='expiryDate'
      name={name}
      type={type}
      placeholder={placeholder}
      guide={false}
      mask={[/\d/, /\d/, '/', /\d/, /\d/]}
      {...props}
    />
  );

  CardCode = ({
    type = 'text',
    name = 'cardCode',
    placeholder = 'CVC',
    ...props
  }) => (
    <this.FormInput
      id='cvv'
      name={name}
      type={type}
      placeholder={placeholder}
      guide={false}
      mask={[/\d/, /\d/, /\d/, /\d?/]}
      {...props}
    />
  );

  render() {
    const { FormInput, ExpDate } = this;
    const { apiErrors, paymentMethod, hidden, buttonText, style } = this.props;
    const { cardNumber, expDate, firstName, lastName, address, city, state, zip } = paymentMethod;
    const validationErrors = runValidations({ expDate }),
          canSubmit = Object.keys(validationErrors).every(key => !validationErrors[key]),
          hasErrors = apiErrors && apiErrors.length > 0;

    return (
      <Fade inProp={!hidden}>
        {hasErrors && (
          <div className='row'>
            <div className='col-xs-12 col-sm-10 col-sm-offset-1'>
              <ul className='apiErrors'>
                {apiErrors.map((message, i) => (
                  <li key={i} className='errorLabelColor'>{message}</li>
                ))}
              </ul>
            </div>
          </div>
        )}

        <br />

        <form className='form-horizontal' style={style || {}}>
          <div className='form-group accept-ui-row'>
            <div className='col-xs-offset-1 col-xs-10 col-sm-5'>
              <FormInput type='text' name='cardNumber' value={cardNumber} disabled={true} />
              <label className='label-normal-font testCardNumberlabel' htmlFor='cardNum'>
                Card Number
              </label>
            </div>
            
            <div className=' col-xs-offset-1 col-sm-offset-0 col-xs-10 col-sm-5'>
              <ExpDate value={expDate} hasError={validationErrors.expDate} />
              <label className='label-normal-font testExpDateLabel focuscolorGreyEffect' htmlFor='expiryDate'>
                Exp. Date
                <span className='glyphicon glyphicon-asterisk asterisk-class'></span>
              </label>
            </div>
          </div>
        
          <div className='form-group accept-ui-row'>
            <div className='col-xs-offset-1 col-xs-10 col-sm-5'>
              <FormInput name='firstName' id='firstName' value={firstName} maxLength='50' />
              <label className='address-focuscolorEffect label-normal-font' htmlFor='firstName'>First Name</label>
            </div>

            <div className='col-xs-offset-1 col-sm-offset-0 col-xs-10 col-sm-5'>
              <FormInput name='lastName' id='lastName' value={lastName} maxLength='50' />
              <label className='address-focuscolorEffect label-normal-font' htmlFor='lastName'>Last Name</label>
            </div>
          </div>

          <div className='form-group accept-ui-row'>
            <div className='col-xs-offset-1 col-xs-10 col-sm-5'>
              <FormInput name='address' id='address' value={address} maxLength='250' />
              <label className='address-focuscolorEffect label-normal-font' htmlFor='address'>Address</label>
            </div>

            <div className='col-xs-offset-1 col-sm-offset-0 col-xs-10 col-sm-5'>
              <FormInput name='city' id='city' value={city} maxLength='100' />
              <label className='address-focuscolorEffect label-normal-font' htmlFor='city'>City</label>
            </div>

            <div className='col-xs-offset-1 col-xs-10 col-sm-5'>
              <StateInput
                CountryCode={'USA'}
                value={state}
                countriesStatesMap={this.props.countriesStatesMap}
                onChange={this.onChangeHandler}
                isRequired={() => true}
              />
              <label className='address-focuscolorEffect label-normal-font' htmlFor='state'>State</label>
            </div>

            <div className='col-xs-offset-1 col-sm-offset-0 col-xs-10 col-sm-5'>
              <FormInput name='zip' id='zip' value={zip} maxLength='5' />
              <label className='address-focuscolorEffect label-normal-font' htmlFor='zip'>Zip</label>
            </div>
          </div>
          
          <div className='form-group'>
            <button
              className='btn btn-primary btn-lg col-xs-offset-1 col-md-offset-2 col-sm-10 col-xs-10 col-md-8 pay-button'
              id='payButton'
              type='button'
              name='Submit'
              disabled={!canSubmit}
              onClick={canSubmit ? this.onHandleSubmit : null}
              style={{marginBottom: '10px'}}
            >
              {buttonText}
            </button>
          </div>
        </form>
      </Fade>
    );
  }
}
